import React from "react";

import StaticPageStyles from "./static_pages.module.css"
import InstagramWarning from "../components/InstagramWarning";

function UserConditions_en() {
    return (
        <div className={StaticPageStyles.staticPageContainer}>
            <InstagramWarning />
            <h1>Terms of Use for LeelaOnline.net</h1>
            <h3>1. Introduction</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Welcome to LeelaOnline.net.</li>
                    <li className={StaticPageStyles.staticPageText}>LeelaOnline.net (the "site") is a digital platform for facilitating the game of Leela.</li>
                    <li className={StaticPageStyles.staticPageText}>The site is designed for playing Leela games online using a digital game board and video conferencing technologies.</li>
                    <li className={StaticPageStyles.staticPageText}>By using this site, you agree to adhere to the terms and conditions outlined below.</li>
                    <li className={StaticPageStyles.staticPageText}>Please review these terms carefully before using our site.</li>
                </ul>
            </p>

            <h3>2. Acceptance of Terms</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>By using our site, you agree to these terms of use, the privacy policy, and any other rules or policies that may be updated.</li>
                    <li className={StaticPageStyles.staticPageText}>If you do not agree with these terms, please do not use our site.</li>
                </ul>
            </p>

            <h3>3. Changes to Terms</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>We reserve the right to change these terms of use at any time without prior notice.</li>
                    <li className={StaticPageStyles.staticPageText}>Your continued use of the site after changes are made will indicate your acceptance of the new terms.</li>
                    <li className={StaticPageStyles.staticPageText}>Any changes will be communicated to you via the email address provided during registration.</li>
                </ul>
            </p>

            <h3>4. Registration</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>To access certain features of our site, you may be required to create an account.</li>
                    <li className={StaticPageStyles.staticPageText}>You agree to provide truthful, accurate, current, and complete information during registration.</li>
                    <li className={StaticPageStyles.staticPageText}>Each user can have only one registered account</li>
                    <li className={StaticPageStyles.staticPageText}>In case of need of new registration while old account exists - old account deletion should be requested via request to the support team</li>
                    <li className={StaticPageStyles.staticPageText}>You are responsible for maintaining the confidentiality of your account and password.</li>
                </ul>
            </p>

            <h3>5. Use of the Site</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>You agree to use our site only for lawful purposes and in accordance with these terms of use.</li>
                    <li className={StaticPageStyles.staticPageText}>You may not:</li>
                    <ul>
                        <li className={StaticPageStyles.staticPageText}>Use the site in any way that violates applicable laws or regulations.</li>
                        <li className={StaticPageStyles.staticPageText}>Use the site to transmit or post any unwanted promotional materials.</li>
                        <li className={StaticPageStyles.staticPageText}>Interfere with or attempt to interfere with the normal operation of the site.</li>
                    </ul>
                </ul>
            </p>

            <h3>6. Intellectual Property</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>All materials on this site, including text, graphics, logos, icons, images, and software, are owned by our company or our licensors and are protected by copyright and intellectual property laws.</li>
                </ul>
            </p>

            <h3>7. Limitation of Liability</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Our site is provided "as is" and "as available" without any warranties, either express or implied.</li>
                    <li className={StaticPageStyles.staticPageText}>We are not responsible for any damages arising from the use or inability to use our site.</li>
                </ul>
            </p>

            <h3>8. Dispute Resolution</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>Any disputes arising from the use of our site should first be resolved through negotiations with the site administration.</li>
                    <li className={StaticPageStyles.staticPageText}>If an agreement cannot be reached, disputes will be resolved in court according to the laws of the country where the site is registered.</li>
                </ul>
            </p>

            <h3>9. Contact Information</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>If you have any questions or concerns regarding these terms of use, please contact us at the email address below.</li>
                    <a href={"mailto:support@leelaonline.net"}>support@leelaonline.net</a>
                </ul>
            </p>
            <br />
            <br />

            <h1>Privacy Policy</h1>
            <a href="/confidential_policy_en" target="_blank">Privacy Policy</a>
        </div>
    );

}

export default UserConditions_en